import { useNavigate } from "react-router-dom";
import type { Citation as CitationT } from "../api/client";

interface Props {
  sourceId: number;
  index: number;
  citations: CitationT[];
}

export default function CitationChip({ sourceId, index, citations }: Props) {
  const navigate = useNavigate();
  const meta = citations.find((c) => c.source_id === sourceId);
  const label = meta?.title ? shorten(meta.title) : `#${sourceId}`;
  const tooltip = meta
    ? [meta.authors, meta.year, meta.title].filter(Boolean).join(" · ")
    : `Source ${sourceId}`;
  return (
    <span
      className="citation-chip"
      onClick={() => navigate(`/library/${sourceId}`)}
      title={tooltip}
    >
      [{index}] {label}
    </span>
  );
}

function shorten(s: string, max = 36) {
  return s.length <= max ? s : s.slice(0, max - 1) + "…";
}
